import { Typography, Box, Button, Chip, Grid } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs';

export const RelatedNewsSection = ({ relatedNews, allNews, isMobile }) => {
    const hasNews = relatedNews && relatedNews.length > 0;
    const navigate = useNavigate();
    return (
        <Box 
            sx={{ 
                bgcolor: 'white', 
                borderRadius: '16px', 
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                p: { xs: 2, sm: 3 }
            }}
        >
            <Typography 
                variant="h6" 
                sx={{ 
                    mb: 3, 
                    fontWeight: 600,
                    borderBottom: '2px solid #e0e0e0',
                    pb: 1.5,
                    position: 'relative',
                    fontSize: { xs: '1.1rem', sm: '1.25rem' },
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        bottom: -2,
                        left: 0,
                        width: '80px',
                        height: '2px',
                        backgroundColor: '#1976d2'
                    } 
                }}
            >
                Noticias relacionadas
            </Typography>

            {!hasNews ? (
                <Typography 
                    variant="body1" 
                    sx={{ textAlign: 'center', my: 2, color: 'gray' }}
                >
                    No hay noticias relacionadas disponibles.
                </Typography>
            ) : (
                isMobile ? (
                    <Grid container spacing={2}>
                        {relatedNews.map((item) => (
                            <Grid item xs={12} sm={6} key={item.id}>
                                <RelatedNewsCard item={item} allNews={allNews} />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <>
                        {relatedNews.map((item) => (
                            <RelatedNewsCard key={item.id} item={item} allNews={allNews} />
                        ))}
                    </>
                )
            )}

            {hasNews && (
                <Button 
                    fullWidth
                    variant="outlined" 
                    color="primary" 
                    sx={{ mt: 2, borderRadius: '8px' }}
                    onClick={() => navigate('/news')}
                >
                    Ver todas
                </Button>
            )}
        </Box>
    );
};


// Componente para la tarjeta de noticia relacionada
const RelatedNewsCard = ({ item, allNews }) => {
    const navigate = useNavigate();

    // Función para formatear fecha
    const formatDate = (dateString) => {
        return dayjs(dateString)
            .tz('America/Santiago')
            .format('D [de] MMMM [de] YYYY');
    };

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                mb: 3,
                borderRadius: '12px',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                boxShadow: '0 3px 8px rgba(0,0,0,0.08)',
                '&:hover': {
                    boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
                    transform: 'translateY(-4px)'
                },
                bgcolor: 'white',
                height: { xs: '120px', sm: '140px' }
            }}
            onClick={() => navigate(`/news/${item.id}`, { state: { news: allNews } })}
            style={{ cursor: 'pointer' }}
        >
            <Box sx={{ 
                width: { xs: '40%', md: '45%' }, 
                minWidth: { xs: '40%', md: '45%' },
                position: 'relative'
            }}>
                <img 
                    src={item.image} 
                    alt={item.title}
                    style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover',
                        display: 'block'
                    }}
                    onError={(e) => {
                        e.target.onerror = null; 
                        e.target.src = 'https://via.placeholder.com/400x300?text=Imagen+no+disponible';
                    }}
                />
                {item.category && (
                    <Chip 
                        label={item.category}
                        size="small"
                        sx={{ 
                            position: 'absolute',
                            top: '8px',
                            left: '8px',
                            fontSize: '0.65rem',
                            height: '20px',
                            bgcolor: 'rgba(25, 118, 210, 0.9)',
                            color: 'white',
                            fontWeight: 600
                        }}
                    />
                )}
            </Box>
            <Box sx={{ p: { xs: 1.5, sm: 2 }, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Typography 
                    variant="subtitle1" 
                    sx={{ 
                        fontWeight: 600,
                        mb: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        lineHeight: 1.4
                    }}
                >
                    {item.title}
                </Typography>
                <Box sx={{ mt: 'auto', display: 'flex', alignItems: 'center', fontSize: '0.75rem', color: '#666' }}>
                    <CalendarTodayIcon sx={{ fontSize: '0.875rem', mr: 0.5 }} />
                    <Typography variant="caption">
                        {formatDate(item.creationDate)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};